import { type UseToastOptions, useToast } from '@chakra-ui/react'
import { useProductAnalytics } from '../api/data/analytics'

const DEFAULT_DURATION_MS = 9000

type BaseToastResponse = ((options: UseToastOptions) => void) & {
  isActive: (id: string) => boolean
  close: (id: string) => void
  closeAll: () => void
  update: (id: string, options: Partial<UseToastOptions>) => void
}

export function useBaseToast(): BaseToastResponse {
  const toast = useToast()
  const { reportEvent } = useProductAnalytics()

  const createToast = (options: UseToastOptions) => {
    const { title, description, duration, isClosable, status } = options

    const safeTitle = title ?? ''
    const safeDescription = description ?? ''
    const safeDuration = duration ?? DEFAULT_DURATION_MS
    const safeIsClosable = isClosable ?? true

    if (status === 'error') {
      reportEvent('alert_shown', { title: safeTitle, description: safeDescription })
    }

    toast({
      ...options,
      title: safeTitle,
      description: safeDescription,
      duration: safeDuration,
      isClosable: safeIsClosable,
    })
  }

  const baseToast = Object.assign(createToast, {
    isActive: toast.isActive,
    close: toast.close,
    closeAll: toast.closeAll,
    update: toast.update,
  })

  return baseToast
}
